import letterhead from '@/views/mydiesel/letterheadkpdn.png'

// AEDuo body/model labels — mirror getAeduoBodyTypeLabel / getAeduoModelTypeLabel in VehicleNewDiesel,
// since AEDuo vehicles carry the codes (PIC/JIP, AE) but not the Name fields the normal letters rely on.
const normalizeCode = (value) => value ? String(value).trim().toUpperCase() : ''

const getAeduoBodyTypeLabel = (vehicle) => {
  const bodyCode = normalizeCode(vehicle && vehicle.vehicleBodyTypeCode)
  if (bodyCode === 'JIP') return '(JIP) - JIP'
  if (bodyCode === 'PIC') return '(PIC) - PICK - UP'
  return ''
}

const getAeduoModelTypeLabel = (vehicle) => {
  const modelCode = normalizeCode(vehicle && vehicle.vehicleModelTypeCode)
  if (modelCode === 'AE') return '(AE) - PSDN-JIP/VAN/BAS/KVN SYKT'
  return ''
}

const content = (registerForm, awamList, baranganList, oilcompanyList, dateFormatted, nextMonth) => {
  const firstPageLimit = 55
  const followUpPageLimit = 55
  const vehicleContentA = []
  const vehicleContentB = []
  for (var awamIndex in awamList) {
    var vehicleA = awamList[awamIndex]
    const bodyText = getAeduoBodyTypeLabel(vehicleA) || (vehicleA.vehicleBodyTypeName ? `${vehicleA.vehicleBodyTypeCode ? `(${vehicleA.vehicleBodyTypeCode}) - ` : ''}${vehicleA.vehicleBodyTypeName}` : '-')
    const modelText = getAeduoModelTypeLabel(vehicleA) || (vehicleA.vehicleModelTypeName ? `${vehicleA.vehicleModelTypeCode ? `(${vehicleA.vehicleModelTypeCode}) - ` : ''}${vehicleA.vehicleModelTypeName}` : '-')
    const bodyShrink = bodyText.length >= 28 ? true : false
    const modelShrink = modelText.length >= 38 ? true : false
    vehicleContentA.push(`
      <tr>
        <td style="width: 5%; overflow: hidden; white-space: nowrap;">${parseInt(awamIndex) + 1}.</td>
        <td style="width: 15%; overflow: hidden; white-space: nowrap;">${vehicleA.vehicleNumber}</td>
        <td style="width: 15%; overflow: hidden; white-space: nowrap;">PSDN - SYKT</td>
        <td style="width: 25%; overflow: hidden; white-space: nowrap;">${bodyText}</td>
        <td style="width: 30%; overflow: hidden; white-space: nowrap;">${modelText}</td>
        <td style="width: 10%; overflow: hidden; white-space: nowrap;">${vehicleA.vehicleRoadTaxEndDate ? vehicleA.vehicleRoadTaxEndDate : '-'}</td>
      </tr>
    `)
  }
  for (var baranganIndex in baranganList) {
    var vehicleB = baranganList[baranganIndex]
    const bodyText = getAeduoBodyTypeLabel(vehicleB) || (vehicleB.vehicleBodyTypeName ? `${vehicleB.vehicleBodyTypeCode ? `(${vehicleB.vehicleBodyTypeCode}) - ` : ''}${vehicleB.vehicleBodyTypeName}` : '-')
    const modelText = getAeduoModelTypeLabel(vehicleB) || (vehicleB.vehicleModelTypeName ? `${vehicleB.vehicleModelTypeCode ? `(${vehicleB.vehicleModelTypeCode}) - ` : ''}${vehicleB.vehicleModelTypeName}` : '-')
    const bodyShrink = bodyText.length >= 28 ? true : false
    const modelShrink = modelText.length >= 38 ? true : false
    vehicleContentB.push(`
      <tr>
        <td style="width: 5%; overflow: hidden; white-space: nowrap;">${parseInt(baranganIndex) + 1}.</td>
        <td style="width: 15%; overflow: hidden; white-space: nowrap;">${vehicleB.vehicleNumber}</td>
        <td style="width: 15%; overflow: hidden; white-space: nowrap;">PSDN - SYKT</td>
        <td style="width: 25%; overflow: hidden; white-space: nowrap;">${bodyText}</td>
        <td style="width: 30%; overflow: hidden; white-space: nowrap;">${modelText}</td>
        <td style="width: 10%; overflow: hidden; white-space: nowrap;">${vehicleB.vehicleRoadTaxEndDate ? vehicleB.vehicleRoadTaxEndDate : '-'}</td>
      </tr>
    `)
  }
  const vehicleContentFinal = vehicleContentA.concat(vehicleContentB)
  // Split the vehicle content into pages: the first page has `firstPageLimit` items,
  // subsequent pages have `followUpPageLimit` items each.
  const vehicleContentSplit = []
  if (vehicleContentFinal.length > 0) {
    // First page
    vehicleContentSplit.push(vehicleContentFinal.slice(0, firstPageLimit))
    // Remaining pages, if any
    for (let start = firstPageLimit; start < vehicleContentFinal.length; start += followUpPageLimit) {
      vehicleContentSplit.push(vehicleContentFinal.slice(start, start + followUpPageLimit))
    }
  }
  
  // Generate pages based on vehicleContentSplit
  const pages = vehicleContentSplit.map((pageContent, pageIndex) => {
    const isFirstPage = pageIndex === 0
    const contentClass = isFirstPage ? 'content' : 'content2'
    
    return `
  <div class="parent page${pageIndex + 1}">
    <div class="header">
      <img id="letterhead" class="letterhead" src="${letterhead}"/>
    </div>
    <div class="${contentClass}">
      <div class="ptitle">
        <p>SENARAI KENDERAAN YANG LAYAK MEMBELI DIESEL BERSUBSIDI</p><br>
      </div>
      <p style="color: blue"><b>${registerForm.userGeneralName}</b> </p>
      ${pageContent.length > 0 ? `
        <table style="width: 100%;">
          <tr>
            <th>NO.</th>
            <th>NO. PENDAFTARAN</th>
            <th>SEKTOR PENGANGKUTAN</th>
            <th>PENGGUNAAN KELAS</th>
            <th>JENIS PENGGUNAAN</th>
            <th>TARIKH LUPUT CUKAI JALAN</th>
          </tr>
          ${pageContent.join('')}
        </table>
        ` : ''
      }
      <div class="prightsmallfont">
        <p style="font-size: 10px; font-weight: bold; margin-top: 5px;">*Surat cetakan komputer ini tidak memerlukan sebarang tandatangan</p><br>
      </div>
    </div>
  </div>`
  }).join('')

  return `
<!DOCTYPE html>
<html>
<head>
<style>
  @media print {
    @page {
      size: A4;
      margin: 0;
    }
    body {
      margin: 0 !important;
    }

    * {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }

  body {
    margin: 0px;
  }

  .backgroundImage {
    display: flex;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 210mm;
    z-index: -999;
  }

  .parent {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    width: 210mm;
    height: 297mm;
    position: relative;
    page-break-after: always;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: visible;
    width: 159.2mm;
    height: 20mm;
    margin-top: 25.4mm;
  }

  .letterhead {
    display: flex;
    width: 159mm;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: visible;
    width: 159.2mm;
    height: 216.2mm;
    margin-top: 10mm;
  }

  .content2 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: visible;
    width: 159.2mm;
    height: 246.2mm;
    margin-top: 10mm;
  }

  p {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
  }

  .pright{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    width: 100%;
  }

  .prightopacity{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 23px;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    opacity: 0.2;
    width: 100%;
  }

  .prightsmallfont{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 3mm;
    font-style: bold;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    width: 100%;
  }

  .pjustify {
    text-align: justify;
  }

  .pmarginleft{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    margin-left: 10px;
    line-height: 4mm;
  }

  .ptitle {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: center;
    width: 100%;
    color: var(--v4-login-button);
    font-weight: bold;
  }

  .hline {
    width: 100%;
    height: 2px;
    border-top: 1px black solid;
  }

  /* dev colors */
  .page1 {
  }
  .page2 {
  }

  table, th, td {
    border: 1px solid grey;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 2mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: center;
    border-collapse: collapse;
  }
</style>
</head>
<body>
${pages}
</body>
</html>`
}
export default {
  content
}


// WEBPACK FOOTER //
// ./src/views/mydiesel/suratsenaraikenderaan_aeduo.js